<div class="order-details">
  <p>{{ "modeso_order_short-email-details_you-will-receive-email" | injectedText | async }}</p>
  <div class="order-id-date">
    {{ "modeso_order_short-email-details_order-referece-caption" | injectedText | async }} <span>{{orderId}}</span> |
    {{ "modeso_order_short-email-details_order-delviery-date-caption" | injectedText | async }}
    <span>{{deliveryDate}}</span>
  </div>
</div>
